/*===========================
##########MAIN MENU##########

=====PLUGINS=====    
  #Bootstrap Input Spinner --- Documentation ---  https://shaack.com/projekte/bootstrap-input-spinner/
      -bootstrap-input-spinner.js
        -custom-editors.js
        
=====CUSTOM JS=====        
  #Global Javascript
      -Bootstrap Input Spinner Implementation
    #Bootstrap Tooltips
    #LazyLoad
    #Hamburger Menu Icon
    #Site Navigation
    #Cart Drawer
    #Hero
    #Product Page
      - Variant Selection Code
  #Select Callback
      -Variables
        -Adjust Pure Number To Money Format
        -Product Page Changes
  #FAQ Page
    #Product Recommendations
    #Variant Out Of Stock Manager
    
=====SLIDERS=====
  #Product Item Card Slider
    #Product Image Slider
    
    

===========================*/

/*###############
  #PLUGINS
###############*/

/*===============================
  #Bootstrap Input Spinner
==============================*/

/*=====bootstrap-input-spinner.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

/*=====FIXES=====*/
$(document).ready(function () {
  $(".form-control").attr("aria-label", "Quantity Input");
});

(function ($) {
  "use strict";

  // the default editor for parsing and rendering
  var I18nEditor = function (props, element) {
    var locale = props.locale || "en-US";

    this.parse = function (customFormat) {
      var numberFormat = new Intl.NumberFormat(locale);
      var thousandSeparator =
        numberFormat.format(11111).replace(/1/g, "") || ".";
      var decimalSeparator = numberFormat.format(1.1).replace(/1/g, "");
      return parseFloat(
        customFormat
          .replace(new RegExp(" ", "g"), "")
          .replace(new RegExp("\\" + thousandSeparator, "g"), "")
          .replace(new RegExp("\\" + decimalSeparator), ".")
      );
    };

    this.render = function (number) {
      var decimals = parseInt(element.getAttribute("data-decimals")) || 0;
      var digitGrouping = !(
        element.getAttribute("data-digit-grouping") === "false"
      );
      var numberFormat = new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: digitGrouping,
      });
      return numberFormat.format(number);
    };
  };

  var triggerKeyPressed = false;
  var originalVal = $.fn.val;
  $.fn.val = function (value) {
    if (arguments.length >= 1) {
      for (var i = 0; i < this.length; i++) {
        if (this[i]["bootstrap-input-spinner"] && this[i].setValue) {
          this[i].setValue(value);
        }
      }
    }
    return originalVal.apply(this, arguments);
  };

  $.fn.inputSpinner = function (methodOrProps) {
    if (methodOrProps === "destroy") {
      this.each(function () {
        if (this["bootstrap-input-spinner"]) {
          this.destroyInputSpinner();
        } else {
          //console.warn("element", this, "is no bootstrap-input-spinner");
        }
      });
      return this;
    }

    var props = {
      decrementButton: "<strong>&minus;</strong>", // button text
      incrementButton: "<strong>&plus;</strong>", // ..
      groupClass: "", // css class of the resulting input-group
      buttonsClass: "btn-outline-secondary",
      buttonsWidth: "2.5rem",
      textAlign: "center", // alignment of the entered number
      autoDelay: 500, // ms threshold before auto value change
      autoInterval: 50, // speed of auto value change, set to `undefined` to disable auto-change
      buttonsOnly: false, // set this `true` to disable the possibility to enter or paste the number via keyboard
      keyboardStepping: true, // set this to `false` to disallow the use of the up and down arrow keys to step
      locale: navigator.language, // the locale, per default detected automatically from the browser
      editor: I18nEditor, // the editor (parsing and rendering of the input)
      // the template of the input
      template:
        '<div class="input-group ${groupClass}">' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button>' +
        '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/>' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button>' +
        "</div>",
    };

    for (var option in methodOrProps) {
      // noinspection JSUnfilteredForInLoop
      props[option] = methodOrProps[option];
    }

    var html = props.template
      .replace(/\${groupClass}/g, props.groupClass)
      .replace(/\${buttonsWidth}/g, props.buttonsWidth)
      .replace(/\${buttonsClass}/g, props.buttonsClass)
      .replace(/\${decrementButton}/g, props.decrementButton)
      .replace(/\${incrementButton}/g, props.incrementButton)
      .replace(/\${textAlign}/g, props.textAlign);

    this.each(function () {
      if (this["bootstrap-input-spinner"]) {
        //console.warn("element", this, "is already a bootstrap-input-spinner");
      } else {
        var $original = $(this);
        $original[0]["bootstrap-input-spinner"] = true;
        $original.hide();
        $original[0].inputSpinnerEditor = new props.editor(props, this);

        var autoDelayHandler = null;
        var autoIntervalHandler = null;

        var $inputGroup = $(html);
        var $buttonDecrement = $inputGroup.find(".btn-decrement");
        var $buttonIncrement = $inputGroup.find(".btn-increment");
        var $input = $inputGroup.find("input");
        var $label = $("label[for='" + $original.attr("id") + "']");
        if (!$label[0]) {
          $label = $original.closest("label");
        }

        var min = null;
        var max = null;
        var step = null;

        updateAttributes();

        var value = parseFloat($original[0].value);
        var pointerState = false;

        var prefix = $original.attr("data-prefix") || "";
        var suffix = $original.attr("data-suffix") || "";

        if (prefix) {
          var prefixElement = $(
            '<span class="input-group-text">' + prefix + "</span>"
          );
          $inputGroup.find("input").before(prefixElement);
        }
        if (suffix) {
          var suffixElement = $(
            '<span class="input-group-text">' + suffix + "</span>"
          );
          $inputGroup.find("input").after(suffixElement);
        }

        $original[0].setValue = function (newValue) {
          setValue(newValue);
        };
        $original[0].destroyInputSpinner = function () {
          destroy();
        };

        var observer = new MutationObserver(function () {
          updateAttributes();
          setValue(value, true);
        });
        observer.observe($original[0], { attributes: true });

        $original.after($inputGroup);

        setValue(value);

        $input
          .on("paste input change focusout", function (event) {
            var newValue = $input[0].value;
            var focusOut = event.type === "focusout";
            newValue = $original[0].inputSpinnerEditor.parse(newValue);
            setValue(newValue, focusOut);
            dispatchEvent($original, event.type);
          })
          .on("keydown", function (event) {
            if (props.keyboardStepping) {
              if (event.which === 38) {
                // up arrow pressed
                event.preventDefault();
                if (!$buttonDecrement.prop("disabled")) {
                  stepHandling(step);
                }
              } else if (event.which === 40) {
                // down arrow pressed
                event.preventDefault();
                if (!$buttonIncrement.prop("disabled")) {
                  stepHandling(-step);
                }
              }
            }
          })
          .on("keyup", function (event) {
            // up/down arrow released
            if (
              props.keyboardStepping &&
              (event.which === 38 || event.which === 40)
            ) {
              event.preventDefault();
              resetTimer();
            }
          });

        // decrement button
        onPointerDown($buttonDecrement[0], function () {
          if (!$buttonDecrement.prop("disabled")) {
            pointerState = true;
            stepHandling(-step);
          }
        });
        // increment button
        onPointerDown($buttonIncrement[0], function () {
          if (!$buttonIncrement.prop("disabled")) {
            pointerState = true;
            stepHandling(step);
          }
        });
        onPointerUp(document.body, function () {
          if (pointerState === true) {
            resetTimer();
            dispatchEvent($original, "change");
            pointerState = false;
          }
        });
      }

      function setValue(newValue, updateInput) {
        if (updateInput === undefined) {
          updateInput = true;
        }
        if (isNaN(newValue) || newValue === "") {
          $original[0].value = "";
          if (updateInput) {
            $input[0].value = "";
          }
          value = NaN;
        } else {
          newValue = parseFloat(newValue);
          newValue = Math.min(Math.max(newValue, min), max);
          $original[0].value = newValue;
          if (updateInput) {
            $input[0].value = $original[0].inputSpinnerEditor.render(newValue);
          }
          value = newValue;
        }
      }

      function destroy() {
        $original.prop("required", $input.prop("required"));
        observer.disconnect();
        resetTimer();
        $input.off("paste input change focusout");
        $inputGroup.remove();
        $original.show();
        $original[0]["bootstrap-input-spinner"] = undefined;
        if ($label[0]) {
          $label.attr("for", $original.attr("id"));
        }
      }

      function dispatchEvent($element, type) {
        if (type) {
          setTimeout(function () {
            var event;
            if (typeof Event === "function") {
              event = new Event(type, { bubbles: true });
            } else {
              // IE
              event = document.createEvent("Event");
              event.initEvent(type, true, true);
            }
            $element[0].dispatchEvent(event);
          });
        }
      }

      function stepHandling(step) {
        calcStep(step);
        resetTimer();
        if (props.autoInterval !== undefined) {
          autoDelayHandler = setTimeout(function () {
            autoIntervalHandler = setInterval(function () {
              calcStep(step);
            }, props.autoInterval);
          }, props.autoDelay);
        }
      }

      function calcStep(step) {
        if (isNaN(value)) {
          value = 0;
        }
        setValue(Math.round(value / step) * step + step);
        dispatchEvent($original, "input");
      }

      function resetTimer() {
        clearTimeout(autoDelayHandler);
        clearTimeout(autoIntervalHandler);
      }

      function updateAttributes() {
        // copy properties from original to the new input
        if ($original.prop("required")) {
          $input.prop("required", $original.prop("required"));
          $original.removeAttr("required");
        }
        $input.prop("placeholder", $original.prop("placeholder"));
        $input.attr("inputmode", $original.attr("inputmode") || "decimal");
        var disabled = $original.prop("disabled");
        var readonly = $original.prop("readonly");
        $input.prop("disabled", disabled);
        $input.prop("readonly", readonly || props.buttonsOnly);
        $buttonIncrement.prop("disabled", disabled || readonly);
        $buttonDecrement.prop("disabled", disabled || readonly);
        if (disabled || readonly) {
          resetTimer();
        }
        var originalClass = $original.prop("class");
        var groupClass = "";
        // sizing
        if (/form-control-sm/g.test(originalClass)) {
          groupClass = "input-group-sm";
        } else if (/form-control-lg/g.test(originalClass)) {
          groupClass = "input-group-lg";
        }
        var inputClass = originalClass.replace(/form-control(-(sm|lg))?/g, "");
        $inputGroup.prop(
          "class",
          "input-group " + groupClass + " " + props.groupClass
        );
        $input.prop("class", "form-control " + inputClass);

        // update the main attributes
        min =
          isNaN($original.prop("min")) || $original.prop("min") === ""
            ? -Infinity
            : parseFloat($original.prop("min"));
        max =
          isNaN($original.prop("max")) || $original.prop("max") === ""
            ? Infinity
            : parseFloat($original.prop("max"));
        step = parseFloat($original.prop("step")) || 1;
        if ($original.attr("hidden")) {
          $inputGroup.attr("hidden", $original.attr("hidden"));
        } else {
          $inputGroup.removeAttr("hidden");
        }
        if ($original.attr("id")) {
          $input.attr("id", $original.attr("id") + "_MP_cBdLN29i2");
          if ($label[0]) {
            $label.attr("for", $input.attr("id"));
          }
        }
      }
    });

    return this;
  };

  function onPointerUp(element, callback) {
    element.addEventListener("mouseup", function (e) {
      callback(e);
    });
    element.addEventListener("touchend", function (e) {
      callback(e);
    });
    element.addEventListener("keyup", function (e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        triggerKeyPressed = false;
        callback(e);
      }
    });
  }

  function onPointerDown(element, callback) {
    element.addEventListener("mousedown", function (e) {
      if (e.button === 0) {
        e.preventDefault();
        callback(e);
      }
    });
    element.addEventListener("touchstart", function (e) {
      if (e.cancelable) {
        e.preventDefault();
      }
      callback(e);
    });
    element.addEventListener("keydown", function (e) {
      if ((e.keyCode === 32 || e.keyCode === 13) && !triggerKeyPressed) {
        triggerKeyPressed = true;
        callback(e);
      }
    });
  }
})(jQuery);

/*=====custom-editors.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

var customEditors = {
  RawEditor: function (props, element) {
    this.parse = function (customFormat) {
      // parse nothing
      return customFormat;
    };
    this.render = function (number) {
      // render raw
      return number;
    };
  },
  TimeEditor: function (props, element) {
    // could be implemented more elegant maybe, but works
    this.parse = function (customFormat) {
      var trimmed = customFormat.trim();
      var sign = 1;
      if (trimmed.charAt(0) === "-") {
        sign = -1;
        trimmed = trimmed.replace("-", "");
      }
      var parts = trimmed.split(":");
      var hours = 0,
        minutes;
      if (parts[1]) {
        hours = parseInt(parts[0], 10);
        minutes = parseInt(parts[1], 10);
      } else {
        minutes = parseInt(parts[0], 10);
      }
      return (hours * 60 + minutes) * sign;
    };
    this.render = function (number) {
      var minutes = Math.abs(number % 60);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var hours;
      if (number >= 0) {
        hours = Math.floor(number / 60);
        return hours + ":" + minutes;
      } else {
        hours = Math.ceil(number / 60);
        return "-" + Math.abs(hours) + ":" + minutes;
      }
    };
  },
};

/*=========================
  #Global Javascript
=========================*/

/*=====Bootstrap Input Spinner Implementation=====*/

$("input[type='number']").inputSpinner();

/*==========================
  #Bootstrap Tooltips
==========================*/
const tooltips = document.querySelectorAll("bootstrap-tooltip");
tooltips.forEach((t) => {
  new bootstrap.Tooltip(t);
});

/*================
  #LazyLoad
================*/
var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

/*===========================
  #Hamburger Menu Icon
===========================*/
const menuBtn = document.querySelector(".navbar-toggler-icon");
let menuOpen = false;
menuBtn.addEventListener("click", () => {
  if (!menuOpen) {
    menuBtn.classList.add("open");
    menuOpen = true;
  } else {
    menuBtn.classList.remove("open");
    menuOpen = false;
  }
});

/*=======================
  #Site Navigation
=======================*/
// MOBILE ADJUSTMENTS

// OPEN MOBILE NAVIGATION
$(".site-navigation-body__hamburger").on("click", function () {
  $(".body-blackout").removeClass("hidden");
  $(".site-navigation-body__menu").addClass("show");
  $("body").addClass("locked");
});

// CLOSE WHEN CLICKING X
$(".site-navigation-body__close").on("click", function () {
  $(".body-blackout").addClass("hidden");
  $(".site-navigation-body__menu").removeClass("show");
  $("body").removeClass("locked");
  $('.qvp-slider').slick('unslick');
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  $(".body-blackout").addClass("hidden");
  $(".site-navigation-body__menu").removeClass("show");
  $("#navbarNav").removeClass("show");
  $("body").removeClass("locked");
  $('.size-guide').removeClass('active');
  $('.quickview-popup').addClass('hidden');

});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    $(".body-blackout").addClass("hidden");
    $(".site-navigation-body__menu").removeClass("show");
    $("#navbarNav").removeClass("show");
    $("body").removeClass("locked");
  }
});

/*========================
  #LAYOUT 2 SPECIFIC
========================*/

// SEARCH FUNCTIONALITY

$(".site-navigation-body__icons--search").on("click", function () {
  $(".slideout-search-bar").toggleClass("show");
});

$(".site-navigation-body__icons--search").keypress(function (e) {
  if (event.which == 13) {
    $(".slideout-search-bar").toggleClass("show");
  }
});

/*=======================
  #Cart Drawer
=======================*/
function updateProgressBar() {
  const includedShippingDiv = document.querySelector('.included-shipping');
  const progressBar = document.querySelector('.included-shipping .progress-bar');
  const shippingIncludedAmount = document.querySelector('.shipping-included-amount');
  let freeShipAmount = parseInt(includedShippingDiv.dataset.freeShipAmount);
  let currentCartTotal = parseInt(includedShippingDiv.dataset.total);
  let amountLeft = (freeShipAmount - currentCartTotal) / 100;
  const progressPercentage = ((currentCartTotal / freeShipAmount).toFixed(2) * 100);
  progressBar.style.width = `${progressPercentage}%`;
  progressBar.ariaValueNow = progressPercentage;

  let formattedAmountLeft = (amountLeft <= 0) ? 0 : amountLeft.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (formattedAmountLeft <= 0) {
    document.querySelector('#free-ship-eligible .not-eligible-text').classList.add('d-none');
    document.querySelector('#free-ship-eligible .eligible-text').classList.remove('d-none');
  }
  else {
    document.querySelector('#free-ship-eligible .not-eligible-text').classList.remove('d-none');
    document.querySelector('#free-ship-eligible .eligible-text').classList.add('d-none');
  }
  shippingIncludedAmount.innerHTML = formattedAmountLeft;
}
// $(document).ready(function() {
//   updateProgressBar();
// });
var openCart = function () {
  $(".cart-drawer-body").addClass("open");
  $(".body-blackout").removeClass("hidden");
  $("body").addClass("locked");
};
var closeCart = function () {
  $(".body-blackout").addClass("hidden");
  $(".cart-drawer-body").removeClass("open");
  $("body").removeClass("locked");
};

var trashCan =
  '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.125 4.12476H15.8203V1.35913H8.17969V4.12476H1.875V5.48413H4.35938V20.4841C4.35938 21.156 4.60156 21.7341 5.08594 22.2185C5.57031 22.7029 6.14844 22.9451 6.82031 22.9451H17.1797C17.8516 22.9451 18.4297 22.7029 18.9141 22.2185C19.3984 21.7341 19.6406 21.156 19.6406 20.4841V5.48413H22.125V4.12476ZM9.44531 2.69507H14.4844V4.12476H9.44531V2.69507ZM18.3047 20.4841C18.3047 20.781 18.1914 21.0427 17.9648 21.2693C17.7383 21.4958 17.4766 21.6091 17.1797 21.6091H6.82031C6.52344 21.6091 6.26172 21.4958 6.03516 21.2693C5.80859 21.0427 5.69531 20.781 5.69531 20.4841V5.48413H18.3047V20.4841Z" fill="#1A1A1A"/></svg>';
var emptyCartMessage = $(".cart-drawer-body__body").data("empty-cart-title");

// Main function that updates the cart drawer
var updateCartDrawer = function (event, data) {
  // console.log(data);

  $.ajax({
    type: "get",
    url: window.Shopify.routes.root + "cart.js",
    dataType: "json",
    success: function (response) {
      // Parse cart response into json
      var cart = response;

      // const cartTotalPrice = cart.total_price;
      // document.querySelector('.included-shipping').dataset.total = cartTotalPrice;
      // updateProgressBar();

      // Set Cart Qty in icon
      var cartCount = cart.item_count;
      //desktop
      $(".announcement-bar-body__icons--cart-count").html(cartCount);
      //mobile
      $(".site-navigation-body__icons--cart-count").html(cartCount);

      var cartItems = [];

      //find kitchen base item and feature items
      let kitchenBaseItem = null;
      let kitchenFeatureItems = [];
      let kitchenItemIds = [];
      let otherItems = [];
      $(cart.items).each(function () {
        if (this.product_type === "Kitchen Island") {
          kitchenBaseItem = this;
          kitchenItemIds.push(this.variant_id);
        }
        else if (this.product_type === "Kitchen Island Pre-Built") {
          kitchenBaseItem = this;
          kitchenItemIds.push(this.variant_id);
        }
        else if (this.product_type === "Kitchen Island Feature") {
          kitchenFeatureItems.push(this);
          kitchenItemIds.push(this.variant_id);
        }
        else {
          otherItems.push(this);
        }
      });
      for (let kitchenFeatureItem of kitchenFeatureItems) {
        kitchenBaseItem.price += kitchenFeatureItem.price; //add price of feature option to base item        
      }
      //reorder kitchenFeatureItem according to names
      const sortOrder = ['Siding Type', 'Siding Color', 'Countertop Tile', 'Grill Head', 'Door/Drawer', 'Second Door/Drawer', 'Refrigerator', 'Side Burner', 'Umbrella Hole', 'Bottle Opener', 'Sink'];
      kitchenFeatureItems.sort((a, b) => {        
        const indexA = sortOrder.indexOf(a.product_title);
        const indexB = sortOrder.indexOf(b.product_title);
        // If both items are found in sortOrder, sort by their position
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        // If only a is found, it comes first
        if (indexA !== -1) {
          return -1;
        }
        // If only b is found, it comes first
        if (indexB !== -1) {
          return 1;
        }
        // If neither is found, maintain original order
        return 0;
      });
      console.log('kitchenFeatureItems',kitchenFeatureItems);

      // console.log([kitchenBaseItem, kitchenFeatureItems]);
      if (kitchenBaseItem) {

        /* BEGIN Build url param for Edit button */
        let featureUrlParams = "";
        if (kitchenFeatureItems.length > 0) {
          featureUrlParams = "EditMode=true";
          for (let option of kitchenBaseItem.options_with_values) {
            featureUrlParams += `&${option.name.replace(" ", "")}=${option.value}`;
          }

          //first, check to see if the Siding Type from product_title exists in the kitchenFeatureItems
          let sidingTypeExists = false;
          for (let kitchenFeatureItem of kitchenFeatureItems) {          
            const featureParamName = getParamNameFromProductTitle(kitchenFeatureItem.product_title);
            if (featureParamName === 'Siding Type') {
              sidingTypeExists = true;
              break;
            }
          }
          if (!sidingTypeExists) {
            featureUrlParams += `&SidingType=No Siding`;
          }      

          for (let kitchenFeatureItem of kitchenFeatureItems) {          
            const featureParamName = getParamNameFromProductTitle(kitchenFeatureItem.product_title);
            if (featureParamName === 'Grill' && !featureUrlParams.includes("CountertopTile")) {
              featureUrlParams += `&CountertopTile=No Tile`;
            }

            featureUrlParams += `&${featureParamName.replace(" ", "").replace("/", "")}=${kitchenFeatureItem.variant_title}`;
            if (featureParamName === 'Siding Type') {
              let sidingColorValue = kitchenFeatureItem.variant_title;
              if (sidingColorValue.includes("Faux Rock")) {
                sidingColorValue = sidingColorValue.split('-')[0].replace("Faux Rock", "").replace("Siding", "").trim();
              }
              featureUrlParams += `&SidingColor=${sidingColorValue}`;            
            }
          }
          if (!featureUrlParams.includes("Refrigerator")) {
            featureUrlParams += `&Refrigerator=Remove fridge`;
          }
          if (!featureUrlParams.includes("SideBurner")) {
            featureUrlParams += `&SideBurner=Remove Side Burner`;
          }
          if (!featureUrlParams.includes("UmbrellaHole")) {
            featureUrlParams += `&UmbrellaHole=No`;
          }
          if (!featureUrlParams.includes("BottleOpener")) {
            featureUrlParams += `&BottleOpener=No`;
          }

          if (otherItems.length > 0) {
            let otherVariantsId = otherItems.map(item => item.variant_id).join(",");
            let otherQuantities = otherItems.map(item => item.quantity).join(",");
            featureUrlParams += `&accVariants=${otherVariantsId}&accQuantities=${otherQuantities}`;      
          }
          //ensure url encoding
          featureUrlParams = encodeURI(featureUrlParams);
          // console.log('featureUrlParams',featureUrlParams);
        }
        /* END Build url param for Edit button */

        let image = (kitchenBaseItem.image) ? kitchenBaseItem.image.replace(/\.(?=[^.]*$)/, '_small.') : "";
        //build the kitchen island item product to look like one product with options
        let item = `
        <div class="cart_item col-12 mt-3 mb-1 border-bottom pb-3" data-var-id="${kitchenBaseItem.variant_id}">
        <div class="row">
          <div class="cart_item__image col-3">
            <a href="${kitchenBaseItem.url}"><img src="${image}" alt="${kitchenBaseItem.product_title}'"></a>            
          </div>
            <div class="cart_item__title col-9">
              <div class="h-100 d-flex flex-column align-items-start justify-content-between">
                <div class="cart_item__title--product">
                  <a class="fw-bold fs-5" href="${kitchenBaseItem.url}">${kitchenBaseItem.product_title}</a><br>
                  <span class="fs-5">${Shopify.formatMoney(kitchenBaseItem.price)}</span>
                </div>`;
        for (let option of kitchenBaseItem.options_with_values) {
          item += `<div class="cart_item__feature w-100 row">
                    <span class="cart_item__feature--option-title col-5">${option.name}: </span>
                    <span class="cart_item__feature--option-value col-7">${option.value}</span>
                  </div>`;
        }
        for (let kitchenFeatureItem of kitchenFeatureItems) {
          item += `<div class="cart_item__feature w-100 row" data-variant-id="${kitchenFeatureItem.variant_id}" data-qty="${kitchenFeatureItem.quantity}">
                    <span class="cart_item__feature--option-title col-5">${kitchenFeatureItem.product_title}: </span>
                    <span class="cart_item__feature--option-value col-7">${kitchenFeatureItem.variant_title}</span>
                  </div>`;
        }
        if (featureUrlParams) {
          item += `<a style="color: #CC1F25 !important;font-weight:bold;text-decoration:underline;" href="${kitchenBaseItem.url.split("?")[0]}?${featureUrlParams}">Edit</a>`;
        }
        item += `
                
                <div class="hidden cart_item__input">
                  <input class="form-control-sm" type="number" value="${kitchenBaseItem.quantity}">
                </div>
            </div>
            <div class="cart_item__delete delete">
            <div class="h-100 d-flex flex-column align-items-end justify-content-between">
                ${trashCan}
              </div>
            </div>
          </div>          
        </div>               
      </div>`;
        cartItems.push(item);
      }

      // Add the HTML for the rest of the products
      $(cart.items).each(function () {
        if (!kitchenItemIds.includes(this.variant_id)) {
          let image = (this.image) ? this.image.replace(/\.(?=[^.]*$)/, '_small.') : "";
          let item = `
            <div class="cart_item col-12 mt-3 mb-1 border-bottom pb-3" data-var-id="${this.variant_id}">
            <div class="row">
              <div class="cart_item__image col-3">
                <a href="${this.url}"><img src="${image}" alt="${this.product_title}'"></a>            
              </div>
                <div class="cart_item__title col-9">
                  <div class="h-100 d-flex flex-column align-items-start justify-content-between">
                    <div class="cart_item__title--product">
                      <a class="fw-bold fs-5" href="${this.url}">${this.product_title}</a><br>
                      <span class="fs-5">${Shopify.formatMoney(this.price)}</span>
                    </div>`;
          if (this.variant_title) {
            for (let option of this.options_with_values) {
              item += `<div class="cart_item__feature w-100 row">
                                  <span class="cart_item__feature--option-title col-5">${option.name}: </span>
                                  <span class="cart_item__feature--option-value col-7">${option.value}</span>
                                </div>`;
            }
          }
          item += `
                      <div class="cart_item__input">
                        <input class="form-control-sm" type="number" value="${this.quantity}">
                      </div>
                  </div>
                  <div class="cart_item__delete delete">
                  <div class="h-100 d-flex flex-column align-items-end justify-content-between">
                      ${trashCan}
                    </div>
                  </div>
                </div>          
              </div>               
            </div>`;
          cartItems.push(item);
        }
      });

      // Clear cart items HTML
      $(".cart-drawer-body__body .cart-item-wrapper").empty();

      for (let cartItem of cartItems) {
        $(".cart-drawer-body__body .cart-item-wrapper").append(cartItem);
      }

      // reinstantiate input spinner
      $("input[type='number']").inputSpinner();

      $(".cart-drawer-body__footer--subtotal--subtotal").html(
        "" + Shopify.formatMoney(cart.items_subtotal_price)
      );

      if (cartItems.length > 0) {
        $(".empty-cart-wrapper").addClass("d-none");
        $(".cart-drawer-body__footer").removeClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").removeClass("d-none");
      } else {
        $(".empty-cart-wrapper").removeClass("d-none");
        $(".cart-drawer-body__footer").addClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").addClass("d-none");
      }
      if (data && data.noCartEvents) { }
      else {
        $("#cart-overlay").fadeOut();
        // Display cart
        openCart();
      }

      let baseTotal = Shopify.formatMoney(cart.items_subtotal_price)
      let shippingThreshold = 4500;
      //console.log(baseTotal);
      //console.log(shippingThreshold);
    }, //Cart success function
    error: function (err) {
      console.log(err);
    },
  });
};

// OPEN CART DRAWER
$(".open-cart-drawer").on("click", function () {
  openCart();
});

$(".open-cart-drawer").keypress(function (event) {
  if (event.which == 13) {
    openCart();
  }
});

// CLOSE WHEN CLICKING X
$(".cart-drawer-hamburger").on("click", function () {
  closeCart();
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  closeCart();
});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    closeCart();
  }
});

// update cart when qty is changed
$(".cart-drawer-body__body").on("change", "input", function () {
  var qty = $(this).val() < 0 ? 0 : $(this).val();
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = qty;
  $("#cart-overlay").show();
  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {
      $("#cart-overlay").fadeOut();
    },
  });
});

// update cart when line is removed
$(".cart-drawer-body__body").on("click", ".delete svg", function () {
  const cartItem = $(this).closest(".cart_item")
  const id = cartItem.data("var-id");
  const featureItems = document.querySelectorAll(`.cart_item[data-var-id="${id}"] .cart_item__feature`);
  var data = {};
  data.updates = {};
  data.updates[id] = 0;

  for (let featureItem of featureItems) {
    if (featureItem.dataset.variantId != undefined) {
      data.updates[parseInt(featureItem.dataset.variantId)] = 0;
    }
  }

  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) { },
  });
});

// Listen for Cart Update event
$("body").on("requestCartUpdate", updateCartDrawer);

/*============
  #Hero
============*/

/*==============
  #Footer
==============*/
$(".footer-body__menu--title-wrapper").on("click", function () {
  let connection = $(this).data("mobile-menu");

  $(".footer-body__menu--linklist." + connection).toggleClass("show");
  $(".menu-control-caret." + connection).toggleClass("show");
});

/*===== Back To Top Button =====*/

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  mybutton = document.getElementById("back-to-top-button");

  if (mybutton) {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }
}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

/*=========================
  #Product Page
=========================*/
if (document.getElementById("AddToCartErr")) {
  var modal = new bootstrap.Modal(document.getElementById("AddToCartErr"));
}

// $( document ).ready(function() {
//   $('.variant-picker-body__swatch--label.label-0').click();
// });


/*=====VARIANT SELECTED INDICATOR*/
$(".variant-picker-body__swatch--input").on("click", function () {
  $(".variant-picker-body__swatch--input").removeClass("checked");
  $(this).addClass("checked");
});
$(".variant-picker-inline--input").on("click", function () {
  $(".variant-picker-inline--input").removeClass("checked");
  $(this).addClass("checked");
});


/*=====PRODUCT TABS JS=====*/
$(".product-template__tabs--tab").on("click", function () {
  let tab = $(this).data("tab-title");
  $(".product-template__tabs--tab").removeClass("active");
  $(this).addClass("active");

  $(".product-template__tab-content--content").removeClass("active");
  $(".product-template__tab-content--content." + tab).addClass("active");
});

/*==========Add To Cart ====================*/
$("body").on("submit", "#product-form", function (e) {
  e.preventDefault();
  var form = $('form[action$="/cart/add"]').serialize();
  $("#cart-overlay").show();
  // AJAX Add To Cart
  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: form,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {
      var response = JSON.parse(err.responseText);
      $("#AddToCartErr .modal-title").html(response.message);
      $("#AddToCartErr .modal-body").html(response.description);
      $("#cart-overlay").fadeOut();
      modal.show();
    },
  });
});

$("body").on("click", ".product-kitchen-template .product-atc", async function (e) {
  e.preventDefault();

  //validate all feature options selected
  const featuresSelected = validateFeaturesSelected();
  if (!featuresSelected) {
    alertFeaturesUnselected();
    return false;
  }

  /* should show atc button spinner */
  toggleAddToCart(false);
  document.querySelector(".product-atc--submit").classList.add("enabled");
  toggleAtcSpinner(true);

  // get current cart items
  const currentCart = await getShopifyCart();
  const currentCartItems = currentCart.items;
  //remove any existing kitchen island or feature products from cart before re-adding another kitchen island
  if (currentCartItems.length > 0) {    
    const removeProductTypes = ["Kitchen Island", "Kitchen Island Pre-Built", "Kitchen Island Feature"];
    const duplicateAccessories = getDuplicateAccessories(currentCartItems);
    const itemsToRemove = [];
    for (let item of currentCartItems) {
      if (removeProductTypes.includes(item.product_type)) {
        itemsToRemove.push({ key: item.key, newQuantity: 0 });
      }
    } 
    for (let item of duplicateAccessories) {
      itemsToRemove.push({ key: item.key, newQuantity: 0 });
    } 
    const cartChanges = await buildCartChanges(itemsToRemove);
    await changeCartItems(cartChanges);    
  }
  //finally, add the kitchen island and all features to the cart
  addKitchenItemsToCart();
});
function getDuplicateAccessories(currentCartItems) {
  const duplicateAccessories = [];
  const optionalAccessories = document.querySelectorAll('input.optional-acc-input[type="number"]');
  const optionalAccessoryIds = [];
  const accessoriesInCart = currentCartItems.map(item => item.variant_id);
  const greaseTrayVariantIds = [49622979641622,49669446926614];
  for (let optionalAccessory of optionalAccessories) {
    const accQty = parseInt(optionalAccessory.value);
    //only factor in a qty of 0 on optional accessories to remove if it is a grease tray and if already in cart
    if ((accQty > 0 || greaseTrayVariantIds.includes(parseInt(optionalAccessory.dataset.variantId))) && accessoriesInCart.includes(parseInt(optionalAccessory.dataset.variantId))) {
        optionalAccessoryIds.push(parseInt(optionalAccessory.dataset.variantId));
    }
  }
  for (let item of currentCartItems) {
    if (optionalAccessoryIds.includes(item.variant_id)) {
      duplicateAccessories.push(item);
    }
  } 

  return duplicateAccessories;
}
async function buildCartChanges(itemsToChange) {
  const changes = {};
  itemsToChange.forEach(item => {
    changes[item.key] = item.newQuantity;
  });
  return changes;
}
async function changeCartItems(cartChanges) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: cartChanges
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const updatedCart = await response.json();
    return updatedCart;
  } catch (error) {
    console.error('Error updating cart:', error);
  }
}
async function getShopifyCart() {
  try {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const cartData = await response.json();
    return cartData;
  } catch (error) {
    console.error('Error fetching cart:', error);
  }
}
function toggleAtcSpinner(show) {
  const atcBtn = document.querySelector('.product-atc--submit .product-atc');
  const spinner = document.querySelector('.product-atc--submit .spinner-border');
  console.log('spinner',spinner);
  if (show) {
    atcBtn.classList.add('invisible');
    spinner.classList.remove('hidden');
  }
  else {
    spinner.classList.add('hidden');
    atcBtn.classList.remove('invisible'); 
  }
}
function addKitchenItemsToCart() {
  const productVariantId = document.querySelector('select[name="id"]').value;
  
  let formData = { 'items': [] };

  /* add any optional accessory products */
  const optionalAccessories = document.querySelectorAll('input.optional-acc-input[type="number"]');
  for (let optionalAccessory of optionalAccessories) {
    const accQty = parseInt(optionalAccessory.value);
    if (accQty > 0) {
      formData.items.push({
        'id': parseInt(optionalAccessory.dataset.variantId),
        'quantity': accQty
      });
    }
  }

  /* add all feature option products */
  const featureAddons = document.querySelectorAll('.feature-select-options.current-variant select.addon-feature-select');
  const addonExclusionTitles = ['no siding', 'no tile', 'no', 'remove side burner', 'remove fridge'];
  for (let featureAddon of featureAddons) {
    const selectedOption = featureAddon.options[featureAddon.selectedIndex];
    if (!addonExclusionTitles.includes(selectedOption.value.toLowerCase())) {
      formData.items.push({
        'id': parseInt(selectedOption.dataset.variantId),
        'quantity': 1
      });
    }
  }

  /* add main product */
  formData.items.push({
    'id': productVariantId,
    'quantity': 1
  });

  $("#cart-overlay").show();
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .then(data => {
    $("body").trigger("requestCartUpdate");
  })
  .catch((error) => {
    console.error('Error:', error);
    var response = JSON.parse(err.responseText);
    $("#AddToCartErr .modal-title").html(response.message);
    $("#AddToCartErr .modal-body").html(response.description);
    $("#cart-overlay").fadeOut();
    modal.show();
  })
  .finally((response) => {
    toggleAtcSpinner(false);
    toggleAddToCart(true);
  });
}

/*==========Variant Selection Code==========*/

// SWATCHES

jQuery(function () {
  jQuery(".swatch :radio").change(function () {
    var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");
  });
});

/* set initial variant options as selected */
document.addEventListener('DOMContentLoaded', () => {
  const productSelect = document.querySelector('#product-form select[name="id"]');
  if (productSelect) {
    const selectedIndex = productSelect.selectedIndex;
    if (selectedIndex !== -1) {
      const selectedOptions = productSelect.options[selectedIndex].text.split("/");
      for (let key in selectedOptions) {
        const optionValue = selectedOptions[key].trim();
        const swatchOptionInput = document.querySelector(`.swatch[data-option-index="${key}"] input[value="${optionValue}"]`);
        if (swatchOptionInput) {
          swatchOptionInput.checked = true;
          $(`.swatch[data-option-index="${key}"]`).trigger("change");
        }
      }

    }
  }
});



/*=======================
  #Select Callback
=======================*/

var selectCallback = function (variant, selector) {
  //console.log('CallBack');
  //   VARIABLES
  var costcoPrice = Shopify.formatMoney(variant.price);
  var regularPrice = Shopify.formatMoney(variant.compare_at_price);

  // PRODUCT PAGE CHANGES
  $(".product-template__body--price .costco-price span").html(costcoPrice);
  $(".product-template__body--price .regular-price span").html(regularPrice);
  updatePriceView();

  //   PRODUCT IMAGE SLIDER FILTERING

  $(".product-image-slider__body").slick("slickUnfilter");
  $(".product-image-slider__thumbnails").slick("slickUnfilter");

  $(".slick-filter-image").removeClass("filter");

  if (variant) {
    var filterIndexes = [];
    $(".swatch").each(function (index, item) {
      var optionName = $(item).data("option-name").toLowerCase();
      if (optionName == "size" || optionName == "color") {
        if ($(this).data("file-alt") && optionName == 'size') {
          //Using Metafields ignoring size (Put in Place for Dearfoams and Baggalinni )
        } else {
          filterIndexes.push(index + 1);
        }
        if (optionName == "color") {
          var color = variant["option" + (index + 1)];
          if ($(item).find(".shown-in").length > 0) {
            $(item).find(".shown-in").html('<b>Selected Style:</b> ' + color);
          } else {
            $(item).prepend(
              '<span class="shown-in pe-2"><b>Selected Style:</b> ' + color + "</span>");
          }
        }
        if (optionName == "size") {
          var color = variant["option" + (index + 1)];
          if ($(item).find(".shown-in").length > 0) {
            $(item).find(".shown-in").html('<b>Selected Size:</b> ' + color + '<span class="show-size-guide">Size & Fit Guide</span>');
          } else {
            //".variant-picker-body__swatch"
            $(item).prepend(
              '<span class="shown-in pe-2 pb-3 d-block"><b>Selected Size:</b> ' +
              color +
              '<span class="show-size-guide">Size & Fit Guide</span></span>'
            );
          }
        }
      }
    });
    var fileName = "";
    //console.log(filterIndexes)
    if (filterIndexes.length > 0) {
      $(filterIndexes).each(function (index, item) {
        var option = "option" + item;
        //console.log(option)
        //console.log(variant[option])
        if (index != 0) {
          fileName += "-";
        }
        fileName += variant[option].replace(/\s/g, "-").replace("#", "").replace(/"/g, "").replace(/\//g, "-");
      });
    }



    fileName = fileName.toLowerCase();
    $(".slick-filter-image").each(function () {
      if ($(this).data("file-alt")) {
        var dataFile = $(this).data("file-alt").toLowerCase().replace(/\s/g, "-").replace("#", "").replace(/"/g, "").replace(/\//g, "-");
        //console.log('With Alt')
      } else {
        var dataFile = $(this).data("file-name").toLowerCase();
        //console.log('Without Alt')
      }




      if (dataFile.indexOf(fileName) > -1) {
        $(this).addClass("filter").addClass('lft-filter');
        //console.log(fileName)
        //console.log(dataFile)
        //console.log('Index Lookup-'+dataFile.indexOf(fileName))
      }
    });

    if ($(".filter").length > 0) {
      $(".product-image-slider__body").slick("slickFilter", ".filter");
      $(".product-image-slider__thumbnails").slick("slickFilter", ".filter");

      // re index thumbnail slides
      $(".product-image-slider__thumbnails .slick-slide").each(function (
        index
      ) {
        var originalIndex = $(this).data('originalIndex');
        $(this).attr("data-slick-index", index);
        if (originalIndex != 'empty') {
          $(this).attr("data-originalIndex", originalIndex);
        }
      });
      // re index main slides
      $(".product-image-slider__body .slick-slide").each(function (index) {
        var originalIndex = $(this).data('originalIndex');
        $(this).attr("data-slick-index", index);
        if (originalIndex != 'empty') {
          $(this).attr("data-originalIndex", originalIndex);
        }
      });

      $(".product-image-slider__thumbnails").slick("slickGoTo", 0);

      if ($(".product-image-slider__thumbnails .slick-track").length < 6) {
        $(".product-image-slider__thumbnails .slick-track")
          .css("transform", "none !important")
          .css("width", "100% !important")
          .css("margin", "0 !important;");
      }
    }
  } //   END IF VARIANT

  //  UPDATE VARIANT SPECIFIC CONTENT

  function decodeEntity(inputStr) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = inputStr;
    return textarea.value;
  }
  if (Object.keys(vmeta[variant.id]).length > 0) {
    for (let i = 1; i < 5; i++) {
      var tabs = Array.from(vmeta[variant.id]);

      $(".product-template__tab-content--content.tab" + i).html(
        decodeEntity(vmeta[variant.id]["tab" + i])
      );
    }
  }
}; // END OF SELECT CALLBACK

/*================
  #FAQ PAGE
================*/

$(".faq-page__question--title").on("click", function () {
  $(this).toggleClass("active");
  $(this).siblings().closest(".faq-page__answer").toggleClass("active");
});

/*===============================
  #Product Recommendations
===============================*/

const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  observer.unobserve(productRecommendationsSection);

  const url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(".product-recommendations");

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
      $(".product-recommendations-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              centerMode: true,
              dots: true,
            },
          },
        ],
      });
    })
    .catch((e) => {
      console.error(e);
    });
};
if ($(".product-recommendations").length > 0) {
  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}

/*====================================
  #Variant Out Of Stock Manager
====================================*/

var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function (selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = jQuery(".swatch:eq(0) :checked");
      break;
    case 1:
      var key = jQuery(".swatch:eq(0) input:checked").val();

      var selector = jQuery(".swatch:eq(1) :checked");
      break;
    case 2:
      var key = jQuery(".swatch:eq(0) :checked").val();
      key += " / " + jQuery(".swatch:eq(1) :checked").val();
      var selector = jQuery(".swatch:eq(2) :checked");
  }
  var initialValue = selector.val();

  var availableOptions = Shopify.optionsMap[key];
  jQuery('.swatch[data-option-index="' + selectorIndex + '"] input').each(
    function () {
      if ($(this).val() !== 'None') {
        if (jQuery.inArray($(this).val(), availableOptions) !== -1) {
          $(this)
            .removeClass("soldout")
            .removeAttr("disabled", "disabled")
            .removeAttr("checked");
        } else {
          $(this)
            .addClass("soldout")
            .removeAttr("checked")
            .attr("disabled", "disabled");
        }
      }
    }
  );
  // if (jQuery.inArray(initialValue, availableOptions) !== -1) {
  //   selector.attr("checked");
  // }
};

Shopify.linkOptionSelectors = function (product) {
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(variant.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);

  // When there is an update in the first dropdown.
  jQuery(".swatch:eq(0)").change(function () {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });

  // When there is an update in the second dropdown.
  jQuery(".swatch:eq(1)").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};

var $addToCartForm = $('form[action="/cart/add"]');
if (window.MutationObserver && $addToCartForm.length) {
  if (
    typeof observer === "object" &&
    typeof observer.disconnect === "function"
  ) {
    observer.disconnect();
  }
  var config = { childList: true, subtree: true };
  var observer = new MutationObserver(function () {
    Shopify.linkOptionSelectors(productObj);
    observer.disconnect();
  });
  observer.observe($addToCartForm[0], config);
}

/*###############
  #SLIDERS
###############*/

$(document).ready(function () { }); // Document Ready Function End
/*================================
  #Hero Slider
================================*/

$(".hero-body-slidshow").slick({
  dots: true,
});

/*================================
  #Product Item Card Slider
================================*/

$(".product-item-card-slider").slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        centerMode: true,
        dots: true,
      },
    },
  ],
});

$(window).on('load', function () {
  //console.log('Slider Ready');
  $(".product-item-card-option-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: false,
    arrows: true
  });
});

/*============================
  #Five Grid Alpha Slider
============================*/


$(".fivegridalpha-slider").slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    }
  ],
});



/*=================================
  #HP Featured Products Slider
=================================*/

$(".hp-featured-products-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    }
  ],
});

/*============================
  #Product Image Slider
============================*/
$(".product-image-slider__body").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  fade: true,
  asNavFor: ".product-image-slider__thumbnails",
});

$(".product-image-slider__thumbnails").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".product-image-slider__body",
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});


/*=====================
  #Lightbox Slider
=====================*/
var zoomSlider

$('.zslidertrigger,.slider-zoom-icon').on('click', function () {
  // console.log('Init')
  var activeSlide = $(this).closest('.product-image-slider').find('.product-image-slider__body .slick-active')[0];
  var slideIndex = $(activeSlide).data('slick-index');
  $('.zslider-blackout').removeClass('hidden');
  $('body').addClass('locked');
  window.scrollTo(0, 0);
  if (!zoomSlider) {
    zoomSlider = $('.zoom-image-slider__body').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      speed: 0,
      responsive: [
        {
          breakpoint: 769,
          settings: {

          }
        }
      ]
    });
  }

  var filterIndexes = [];
  $(".swatch").each(function (index, item) {
    var optionName = $(item).data("option-name").toLowerCase();
    // console.log(optionName);
    if (optionName == "size" || optionName == "color") {
      if ($(this).data("file-alt") != 'undefined' && optionName == 'size') {
        //Using Metafields ignoring size (Put in Place for Dearfoams and Baggalinni )
      } else {
        filterIndexes.push(index + 1);
      }
    }
  });
  var fileName = "";

  if (filterIndexes.length > 0) {
    $(filterIndexes).each(function (index, item) {
      var option = "option" + item;
      if (index != 0) {
        fileName += "-";
      }
      var vName = $('.product-form__input[data-option-index="' + (item - 1) + '"] input:checked');
      vNameFinal = vName[0].defaultValue

      fileName += vNameFinal.replace(/\s/g, "-").replace("#", "").replace(/"/g, "").replace(/\//g, "-");
    });
  }



  fileName = fileName.toLowerCase();
  $(".zslick-filter-image").each(function () {
    if ($(this).data("file-alt") != 'undefined') {
      var dataFile = $(this).data("file-alt").toString().toLowerCase().replace(/\s/g, "-").replace("#", "").replace(/"/g, "").replace(/\//g, "-");
    } else {
      var dataFile = $(this).data("file-name").toString().toLowerCase();
    }

    if (dataFile.indexOf(fileName) > -1) {

      $(this).addClass("filter");
    }

  });
  if ($(".filter").length > 0) {
    zoomSlider.slick("slickFilter", ".filter");

    // re index main slides
    $(".zoom-image-slider__body .slick-slide").each(function (index) {
      $(this).attr("data-slick-index", index);
    });

  }
  console.log(zoomSlider.slick('slickCurrentSlide'));

  console.log('slickGoTo: ' + slideIndex);
  zoomSlider.slick('slickGoTo', slideIndex);

  console.log(zoomSlider.slick('slickCurrentSlide'));

});

$('.close-zoom').on('click', function () {
  $('.zslider-blackout').addClass('hidden');

  $('body').removeClass('locked');
  zoomSlider.slick("slickUnfilter");
  console.log('Unfilter')
});

/* workaround for size option disabled on page load */
$(document).ready(function () {
  triggerPickerSelect();
});
function triggerPickerSelect() {
  const colorPicker = $('input[name="Color"].checked');
  const sizePicker = $('input[name="Size"].checked');
  if (colorPicker.length > 0) {
    colorPicker.trigger('click');
  }
  if (sizePicker.length > 0) {
    setTimeout(() => {
      sizePicker.trigger('click');
    }, 10);
  }
}

/*================
  #Size Guide
===============*/
$('body').on('click', '.show-size-guide', function () {
  $('.size-guide').addClass('active');
  $('body').addClass('locked')
  $('.body-blackout').removeClass('hidden');
});

$('body').on('click', '.size-guide-close', function () {
  $('.size-guide').removeClass('active');
  $('body').removeClass('locked');
  $('.body-blackout').addClass('hidden');
});


/*===============
  #Quickview
==============*/


$('body').on('click', '.quickview', function () {
  // console.log('Quickview Clicked');

  //Slider
  //$('.qvp-slider').html('');//Clear Product Images on Quickview
  $('.quickview-popup .product-details').html('');
  $.get($(this).data('link'), function (data) {    
    var productInfo = $(data).find('.product-template__body')[0];
    var inputs = $(productInfo).find('variant-radios input')
    var labels = $(productInfo).find('variant-radios label')
        
    // console.log(inputs.length + '-' + labels.length)
    $(labels).each(function (index, item) {
      var qvinput = 'qv' + $(this).attr('for');
      $(this).attr('for', qvinput)
    })
    $(inputs).each(function (index, item) {
      var qvinput = 'qv' + $(this).attr('id');
      $(this).attr('id', qvinput)
    })
    $('.quickview-popup .product-details').html(productInfo);
    if ($('input[name="Color"]').length > 0) {
      var colorText = $.parseHTML('<span class="shown-in pe-2"><b>Selected Style:</b> ' + $('input[name="Color"]')[0].value + '</span>')
      $('.quickview-popup input[name="Color"]')[0].closest('fieldset').prepend(colorText[0]);
    }
    if ($('input[name="Size"]').length > 0) {    
      var sizeText = $.parseHTML('<span class="shown-in pe-2 pb-3 d-block"><b>Selected Size:</b> ' + $('input[name="Size"]')[0].value + '</span>')    
      $('.quickview-popup input[name="Size"]')[0].closest('fieldset').prepend(sizeText[0]);
    }
    $('.quickview-popup .product-image-slider__body').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      fade: true,
      asNavFor: ".quickview-popup .product-image-slider__thumbnails"
    });
    $('.quickview-popup .product-image-slider__thumbnails').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      asNavFor: ".quickview-popup .product-image-slider__body",
    });
    $(".quickview-popup input[type='number']").inputSpinner();

    $(".quickview-popup").on("change", ".swatch :radio", function () {
      var optionIndex = $(this).closest(".swatch").attr("data-option-index");
      var optionValue = $(this).val();
      var SetVal = '';

      if ($(this).attr('name') == "Color") {
        var color = optionValue;
        if ($(this).closest('fieldset').find(".shown-in").length > 0) {
          $(this).closest('fieldset').find(".shown-in").html('<b>Selected Style:</b> ' + color);
        } else {
          $(this).closest('fieldset').prepend(
            '<span class="shown-in pe-2"><b>Selected Style:</b> ' + color + "</span>");
        }
      }
      if ($(this).attr('name') == "Size") {
        var size = optionValue;
        if ($(this).closest('fieldset').find(".shown-in").length > 0) {
          $(this).closest('fieldset').find(".shown-in").html('<b>Selected Size:</b> ' + size);
        } else {
          $(this).closest('fieldset').prepend(
            '<span class="shown-in pe-2 pb-3 d-block"><b>Selected Size:</b> ' +
            size +
            "</span>"
          );
        }
      }

      $(".quickview-popup input.variant-picker-body__swatch--input").each(function (index, item) {
        // console.log(item)
        if ($(item).is(':checked')) {
          if (SetVal != '') { SetVal += ' / '; }
          SetVal += $(this).val();
        }
      })
      $('.quickview-popup #product-select option').each(function (index, option) {
        if ($(option).html().trim() == SetVal) {
          $(option).prop('selected', true);
          $('#product-select').val(parseInt($(option).val())).trigger("change");
        }
      })
      if ($(this).attr('name') == 'Color') {
        $('.quickview-popup .product-image-slider__thumbnails').slick("slickUnfilter");
        $('.quickview-popup .product-image-slider__body').slick("slickUnfilter");
        $('.quickview-popup .slick-filter-image').removeClass('filter');
        $('.quickview-popup .slick-filter-image').each(function () {
          if ($(this).data('alt') == optionValue) {
            $(this).addClass('filter');
          }
        });
        if ($('.quickview-popup .slick-filter-image.filter').length > 0) {
          $('.quickview-popup .product-image-slider__thumbnails').slick("slickFilter", ".filter");
          $('.quickview-popup .product-image-slider__body').slick("slickFilter", ".filter");
        }
      }
    });
  });


  //   setTimeout(function(){
  //     $(".qvp-slider").slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       infinite: false,
  //       fade: true
  //     });
  //   }, 100);



  //   let pTitle = $(this).data('title');
  //   let pPrice = $(this).data('price');
  //   let pCompare = $(this).data('compare');
  let pLink = $(this).data('link');
  //   let pId = $(this).data('id');
  //   let pImages = $(this).data('images').split(',');
  //   let pImage = pImages[0];
  //   let pOptions = $(this).data('options').toLowerCase().split(',');
  //   let pValuesSize = $(this).data('valuessize').split(',');
  //   let pValuesColor = $(this).data('valuescolor').split(',');
  //   let pVariantImage = $(this).data('variantimage').split(',');


  $('.quickview-popup').removeClass('hidden');
  $(".body-blackout").removeClass("hidden");
  $("body").addClass("locked");


  //   $('.quickview-popup .qvp-title').html(pTitle); //Product Title on Quickview
  $('.quickview-popup .qvp-link').attr('href', pLink) //Product Link on Quickview
  //   $('.quickview-popup .qvp-id').attr('value', pId) //Product Id on Quickview
  //   $('.quickview-popup .qvp-image').attr('src', pImage) //Initial Product Image on Quickview

  /* hide add to cart on quickview */
  $('.quickview-popup .product-atc').addClass('hidden');

  // //Quick View Options
  //   $.each(pOptions, function(i){
  //     $('.qvp-options').append(`<div class="qvp-${pOptions[i]} option-${pOptions[i]}" style="padding-top:10px;"><div class="" style="padding-bottom:25px;"><b>Selected ${pOptions[i]}:</b></div></div>`);//Product Options on Quickview
  //   });  

  // // Quick View Size Values
  //   $.each(pValuesSize, function(i){
  //     $('.qvp-size').append(`<div class="variant-picker-body__swatch--label" style="">${pValuesSize[i]}</div>`);//Product Value of Size on Quickview
  //   }); 

  // // Quick View Color Values
  //   $.each(pValuesColor, function(i){
  //     $('.qvp-color').append(`<div class="variant-picker-body__swatch--label" style="border-radius: 12px; max-width: unset; display: inline;padding: 10px;"><img src="${pValuesColor[i]}" alt=""></div>`);//Product Value of Color on Quickview
  //   }); 



  //   //Quick View Images
  //   $.each(pImages, function(i){
  //     console.log(pImages[i]);
  //     $('.qvp-slider').append(`<div class=""><img src="${pImages[i]}" alt="QuickView Image" style="float:left;"></div>`);//Product Images on Quickview
  //   });  


  //   if(pCompare != ''){
  //     $('.quickview-popup .qvpprice').html(`Promo Price<br><span class="">${pPrice}</span>`); //Product Price on Quickview with promo
  //     $('.quickview-popup .qvcprice').html(`Costco Price<br><span class=""><s>${pCompare}</s></span>`); //Product Compare At Price on Quickview
  //   }else{
  //     $('.quickview-popup .qvpprice').html(`Costco Price<br><span class="">${pPrice}</span>`); //Product Price on Quickview
  //   }
});


$('body').on('click', '.close-icon', function () {
  // console.log('Clicked Close')
  $('.quickview-popup').addClass('hidden');
  $(".body-blackout").addClass("hidden");
  $("body").removeClass("locked");
  $('.quickview-popup .qvpprice').html('');
  $('.quickview-popup .qvcprice').html('');
  //$('.qvp-slider').slick('unslick');
  $('.qvp-slider').html('');//Clear Product Images on Quickview
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  //$('.qvp-slider').slick('unslick');
  $('.qvp-slider').html('');//Clear Product Images on Quickview
});

// CLOSE QUICKVIEW ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    //$('.qvp-slider').slick('unslick');
    $('.qvp-slider').html('');//Clear Product Images on Quickview
    $('.quickview-popup').addClass('hidden');
  }
});

//CLOSE QUICKVIEW ON HITTING ATC

$('body').on('click', '.product-atc', function () {
  //$('.qvp-slider').slick('unslick');
  $('.qvp-slider').html('');//Clear Product Images on Quickview
  $('.quickview-popup').addClass('hidden');
});




/*========================
  #Filter Adjustments
=======================*/
// $('.open-close-caret').on('click', function () {
//   console.log('Testing');
// });

$('.collection-filters li').on('click', function () {
  $(this).closest('#filter-form').submit();
});

$('.price-checkbox').on('click', function () {
  let minPrice = $(this).data('min')
  let maxPrice = $(this).data('max')

  $('.min-input').val(minPrice)
  $('.max-input').val(maxPrice)
});

$('.mobile-filter-trigger').on('click', function () {
  $('.collection-filter-wrapper').toggleClass('active');
  $('.collection-grid-blackout').toggleClass('active');
  $('body').toggleClass('locked');
});

$('.filter-close').on('click', function () {
  $('.collection-filter-wrapper').removeClass('active');
  $('.collection-grid-blackout').removeClass('active');
  $('body').removeClass('locked');
});

$('.collection-grid-blackout').on('click', function () {
  $('.collection-filter-wrapper').removeClass('active');
  $('.collection-grid-blackout').removeClass('active');
  $('body').removeClass('locked');
});

/** PDP Addons **/
/*
document.addEventListener('DOMContentLoaded', function () {
  const optionLabels = document.querySelectorAll('variant-selects .option--label');
  // console.log("optionLabels", optionLabels)
  for (let optLabel of optionLabels) {
    console.log("optLabel",optLabel);
    optLabel.addEventListener("click", updateViewer)
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const optionInputs = document.querySelectorAll('.product input[data-addon-input]');
  console.log("optionInputs", optionInputs)
  for (let optionInput of optionInputs) {
    console.log("optionInput",optionInput);
    optionInput.addEventListener("change", updateViewer)
  }
});
*/

let setInitialOptions = isEditMode();
if (setInitialOptions) {
  document.querySelector('.step-two-options').classList.add('loading');
  document.querySelector('.step-three-options').classList.add('loading');
  setGasTypeFromParams();
  setFeatureOptionsFromParams();  
  setAccessoryQuantitiesFromParams();  
  setTimeout(() => {
    document.querySelector('.step-two-options').classList.remove('loading');
    document.querySelector('.step-three-options').classList.remove('loading');
    updatePriceView();
  }, 1500);
}
setInitialOptions = false;

document.addEventListener('DOMContentLoaded', function () {
  const atcMobileDropdown = document.querySelector('.product-atc--dropdown');
  if (atcMobileDropdown) {
    atcMobileDropdown.addEventListener('click', function () {
      const atcWrapper = document.querySelector('.product-atc-wrapper');
      if (atcWrapper.classList.contains("open")) {
        atcWrapper.classList.remove("open");
      }
      else {
        atcWrapper.classList.add("open");
      }
    });
  }

  const gasOptions = document.querySelectorAll('input[name="Gas Type"]');
  let priorGasOptionSelected = "None";
  for (let gasOption of gasOptions) {
    gasOption.addEventListener('change', function () {
      const gasTypeModal = new bootstrap.Modal(document.getElementById('confirmGasTypeModal'));
      document.querySelector('.gas-type-selected-text').innerHTML = this.value;
      // console.log('priorGasOptionSelected',priorGasOptionSelected);
      if (priorGasOptionSelected === "None") {
        document.querySelector('.gas-type-initial-title').classList.remove('hidden');
        document.querySelector('.gas-type-changed-title').classList.add('hidden');
        document.querySelector('.gas-type-initial-text').classList.remove('hidden');
        document.querySelector('.gas-type-changed-text').classList.add('hidden');
      }
      else {
        document.querySelector('.gas-type-initial-title').classList.add('hidden');
        document.querySelector('.gas-type-changed-title').classList.remove('hidden');
        document.querySelector('.gas-type-initial-text').classList.add('hidden');
        document.querySelector('.gas-type-changed-text').classList.remove('hidden');
      }
      gasTypeModal.show();

    });
  }

  const featureDropdownItems = document.querySelectorAll('.feature-dropdown-item');
  for (let featureDropdownItem of featureDropdownItems) {
    featureDropdownItem.addEventListener("click", featureUpdated)
  }

  // updatePriceView();
  $("body").trigger("requestCartUpdate", { noCartEvents: true });

  const confirmGasTypeBtn = document.getElementById('confirmGasTypeBtn');
  const cancelGasTypeBtn = document.getElementById('cancelGasTypeBtn');
  if (cancelGasTypeBtn) {
    cancelGasTypeBtn.addEventListener('click', () => {

      document.querySelector('input[name="Gas Type"]').value = priorGasOptionSelected;
      for (let gasOption of gasOptions) {
        if (gasOption.value === priorGasOptionSelected) {
          gasOption.checked = true;
        }
      }
      if (document.querySelector('input[name="Gas Type"]').value === "None") {
        document.querySelector('.step-two-options').classList.remove('active');
        document.querySelector('.step-three-options').classList.remove('active');
      }
      const modal = bootstrap.Modal.getInstance(cancelGasTypeBtn.closest('.modal'));
      modal.hide();
      priorGasOptionSelected = document.querySelector('input[name="Gas Type"]:checked').value;
    });
  }
  if (confirmGasTypeBtn) {
    confirmGasTypeBtn.addEventListener('click', () => {
      const gasOption = document.querySelector('input[name="Gas Type"]:checked');
      updateCurrentProductVariant(gasOption);
      setCurrentVariantFeatureOptions();
      enableSteps();
      updatePriceView();
      const modal = bootstrap.Modal.getInstance(confirmGasTypeBtn.closest('.modal'));
      modal.hide();
      priorGasOptionSelected = document.querySelector('input[name="Gas Type"]:checked').value;
    });
  }
  
  /*=========================
    #hide 'duplicate' siding items for each gas type
  =========================*/
  const featureSelectOptions = document.querySelectorAll('.feature-select-options');
  for (let featureSelectOption of featureSelectOptions) {
    const quartziteSidingItems = featureSelectOption.querySelectorAll('li[data-viewer-value="Quartzite"]');
    let quartziteCounter = 0;
    for (let quartziteSidingItem of quartziteSidingItems) {
      if (quartziteCounter > 0) {
        quartziteSidingItem.classList.add('d-none')
      }
      quartziteCounter++;
    }

    const fauxRockSidingItems = featureSelectOption.querySelectorAll('li[data-viewer-value="Faux Rock"]');
    let fauxRockCounter = 0;
    for (let fauxRockSidingItem of fauxRockSidingItems) {
      if (fauxRockCounter > 0) {
        fauxRockSidingItem.classList.add('d-none')
      }
      fauxRockCounter++;
    }
    // const fauxRockBrahmaSidingItems = featureSelectOption.querySelectorAll('li[data-viewer-value="Faux Rock Brahma"]');
    // if (fauxRockBrahmaSidingItems.length >= 2) {
    //   fauxRockBrahmaSidingItems[1].style.display = 'none';
    // }
  }  

  /*=========================
    #display accessory product data in modal
  =========================*/
  // addon-info-icon
  // .product-loading-indicator
  const addonInfoIcons = document.querySelectorAll('.addon-info-icon');
  for (let addonInfoIcon of addonInfoIcons) {    
    addonInfoIcon.addEventListener('click', () => {
      const dataLink = addonInfoIcon.dataset.link;
      const modalId = addonInfoIcon.dataset.bsTarget;
      const loadingIndicator = document.querySelector(`${modalId} .modal-body .product-loading-indicator`);
      const modalProductContent = document.querySelector(`${modalId} .modal-body .product-content`);
      if (modalProductContent.innerHTML.trim() === '') {
        fetch(dataLink)
          .then((response) => response.text())
          .then((htmlResponse) => {
            const parser = new DOMParser();
            const productHtml = parser.parseFromString(htmlResponse, 'text/html');
            const productTemplateBody = productHtml.querySelector('.product-template__body');
            const html = document.createElement('div');  
            html.classList.add('accessory-modal-content');
            html.innerHTML = productTemplateBody.innerHTML;            
            modalProductContent.insertAdjacentHTML('beforeend', html.innerHTML);
            modalProductContent.querySelector('.product-atc').remove();      
            
            $(`${modalId} .product-image-slider__body`).slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              infinite: false,
              fade: true,
              asNavFor: `${modalId} .product-image-slider__thumbnails`
            });
            $(`${modalId} .product-image-slider__thumbnails`).slick({
              slidesToShow: 5,
              slidesToScroll: 1,
              arrows: true,
              infinite: false,
              asNavFor: `${modalId} .product-image-slider__body`,
            });
            
            loadingIndicator.classList.add('hidden');
          });
      }
    });
  }

  const optionalAccessoriesInputs = document.querySelectorAll('input.optional-acc-input[type="number"]');
  for (let accInput of optionalAccessoriesInputs) {
    accInput.addEventListener('input', () => {
      updatePriceView();
    });
  }
});

function getParamNameFromProductTitle(productTitle) {
  switch (productTitle) {
    case 'Grill Head':
      return 'Grill';
    case 'Refrigeration':
      return 'Refrigerator';
    default:
      return productTitle;
  }
}

function isEditMode() {
  const urlParams = new URLSearchParams(window.location.search);
  const editModeParam = urlParams.get('EditMode');
  const isEditMode = editModeParam === 'true';

  return isEditMode;
}
function setGasTypeFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const gasTypeParam = urlParams.get('GasType');
  const gasOption = document.querySelector(`input[name="Gas Type"][value="${gasTypeParam}"]`);
  if (gasOption) {
    gasOption.checked = true;
    updateCurrentProductVariant(gasOption);
    setCurrentVariantFeatureOptions();
    enableSteps();
    updatePriceView();
    priorGasOptionSelected = gasOption.value;
  }
}
function setFeatureOptionsFromParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const sidingTypeParam = urlParams.get('SidingType')?.replace(/"/g, '\\"');
  const sidingColorParam = urlParams.get('SidingColor')?.replace(/"/g, '\\"');  
  const countertopTileParam = urlParams.get('CountertopTile')?.replace(/"/g, '\\"');  
  const grillParam = urlParams.get('Grill')?.replace(/"/g, '\\"');  
  const sinkParam = urlParams.get('Sink')?.replace(/"/g, '\\"');  
  const doorDrawerParam = urlParams.get('DoorDrawer')?.replace(/"/g, '\\"');  
  const secondDoorDrawerParam = urlParams.get('SecondDoorDrawer')?.replace(/"/g, '\\"');  
  const refrigeratorParam = urlParams.get('Refrigerator')?.replace(/"/g, '\\"');  
  const sideBurnerParam = urlParams.get('SideBurner')?.replace(/"/g, '\\"');  
  const umbrellaHoleParam = urlParams.get('UmbrellaHole')?.replace(/"/g, '\\"');  
  const bottleOpenerParam = urlParams.get('BottleOpener')?.replace(/"/g, '\\"');    

  //due to the mechanism by which the underlying siding type gets selected using both the siding type and the color pseduo options, select the first siding type with the generic value
  let sidingTypeInitial = document.querySelector(`.feature-dropdown-item[data-viewer-label="Siding Type"][data-value="${sidingTypeParam}"]`);
  let sidingTypeSelector = sidingTypeParam;
  if (sidingTypeInitial) {
    sidingTypeSelector = sidingTypeInitial.getAttribute('data-label-unique');
  }
  const sidingTypeDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Siding Type"][data-label-unique="${sidingTypeSelector}"]:not(.d-none)`);
  const sidingColorDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Color"][data-label-unique="${sidingColorParam}"]`);
  const countertopTileDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Countertop Tile"][data-value="${countertopTileParam}"]`);
  const grillDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Grill"][data-value="${grillParam}"]`);
  const sinkDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Sink"][data-value="${sinkParam}"]`);
  const doorDrawerDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Door/Drawer"][data-value="${doorDrawerParam}"]`);
  const secondDoorDrawerDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Second Door/Drawer"][data-value="${secondDoorDrawerParam}"]`);
  const refrigeratorDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Refrigerator"][data-value="${refrigeratorParam}"]`);
  const sideBurnerDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Side Burner"][data-value="${sideBurnerParam}"]`);
  const umbrellaHoleDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Umbrella Hole"][data-value="${umbrellaHoleParam}"]`);
  const bottleOpenerDropdown = document.querySelector(`.feature-dropdown-item[data-viewer-label="Bottle Opener"][data-value="${bottleOpenerParam}"]`);

  const featureDropdownItems = [sidingTypeDropdown, sidingColorDropdown, countertopTileDropdown, grillDropdown, sinkDropdown, doorDrawerDropdown, secondDoorDrawerDropdown, refrigeratorDropdown, sideBurnerDropdown, umbrellaHoleDropdown, bottleOpenerDropdown];
  for (let featureDropdownItem of featureDropdownItems) {
    if (featureDropdownItem) {
      setHiddenFeatureSelect(featureDropdownItem);
      setSidingTypeSelectFromColor();
      customFeatureUpdateLogic(featureDropdownItem);
      setAlternateSidingTypeForGrill();
      updatePriceView();
      updateDropdownItem(featureDropdownItem);
    }
  }

  for (let featureDropdownItem of featureDropdownItems) {
    if (featureDropdownItem) {
      setTimeout(() => {
        updateViewerModel(featureDropdownItem);
      }, 1500);
    }
  }
}

function setAccessoryQuantitiesFromParams() {  
  const urlParams = new URLSearchParams(window.location.search);
  const accVariantsParam = urlParams.get('accVariants');
  const accQuantitiesParam = urlParams.get('accQuantities');
  if (!accVariantsParam || !accQuantitiesParam) {
    return;
  }
  const accVariants = accVariantsParam.split(',');
  const accQuantities = accQuantitiesParam.split(',');
  if (accVariants.length !== accQuantities.length) {
    console.error('accVariants and accQuantities must have the same number of elements');
    return;
  }
  accVariants.forEach((accVariant, index) => {
    const accAddonQtyInput = document.querySelector(`.acc-addon-qty input[data-variant-id="${accVariant}"]`);    
    if (accAddonQtyInput) {
      setTimeout(() => {
        accAddonQtyInput.value = accQuantities[index];
        accAddonQtyInput.parentElement.querySelector('input[type="text"]').value = accQuantities[index];
      }, 1500);
    }
  });
}

function enableSteps() {
  const stepOptions = document.querySelectorAll('.step-two-options, .step-three-options');
  for (let stepOption of stepOptions) {
    stepOption.classList.add('active');
  }
}

function setCurrentVariantFeatureOptions() {
  const currentVariantId = document.querySelector('select[name="id"]').value;
  const featureSelectOptions = document.querySelectorAll('.feature-select-options');
  for (let featureSelectOption of featureSelectOptions) {
    // console.log('featureSelectOption',featureSelectOption);
    if (parseInt(featureSelectOption.dataset.variantId) === parseInt(currentVariantId)) {
      featureSelectOption.classList.add('current-variant');
    }
    else {
      featureSelectOption.classList.remove('current-variant');
    }
  }
}
function updateCurrentProductVariant(gasOption) {
  // console.log('gas option changed', gasOption);
  const gasOptionValue = gasOption.value;
  const productSelect = document.querySelector('select[name="id"]');
  for (let option of productSelect.options) {
    const selectedOptions = option.text.split("/");
    for (let key in selectedOptions) {
      const optionValue = selectedOptions[key].trim();
      if (optionValue === gasOptionValue) {
        // console.log("got it", [optionValue, gasOptionValue]);
        productSelect.value = option.value;
      }
    }
  }
  if (productSelect.value) {
    toggleAddToCart(true);
  }
  else {
    toggleAddToCart(false);
  }
}

function calculateAccessoriesPrice() {
  const optionalAccessories = document.querySelectorAll('input.optional-acc-input[type="number"]');
  let accessoriesPrice = 0;
  for (let accAddon of optionalAccessories) {
    const accAddonPrice = parseInt(accAddon.dataset.price);
    const accAddonQty = parseInt(accAddon.value);
    if (!accAddonQty) {
      continue;
    }
    accessoriesPrice += accAddonPrice * accAddonQty;
  }
  // console.log('accessoriesPrice', accessoriesPrice)
  return accessoriesPrice;
}

function updatePriceView() {
  const productType = document.querySelector('.body--price__wrapper').dataset.productType;  
  const productBasePrice = parseInt(document.querySelector('.costco-price').dataset.priceMin);
  const regularBasePrice = (document.querySelector('.regular-price')) ? parseInt(document.querySelector('.regular-price').dataset.priceMax) : null;
  const accessoriesPrice = calculateAccessoriesPrice();
  let productCurrentPrice = productBasePrice + accessoriesPrice;
  let regularCurrentPrice = regularBasePrice + accessoriesPrice;

  if (productType !== "Kitchen Island") {
    if (productType === "Kitchen Island Pre-Built") {     
      if (document.querySelector('.product-template__body--price .costco-price span')) {
        document.querySelector('.product-template__body--price .costco-price span').innerHTML = Shopify.formatMoney(productCurrentPrice);
      }
      if (document.querySelector('.product-template__body--price .regular-price span')) {
        document.querySelector('.product-template__body--price .regular-price span').innerHTML = Shopify.formatMoney(regularCurrentPrice);
      }
      if (document.querySelector('.product-atc--price-text')) {
        document.querySelector('.product-atc--price-text').innerHTML = Shopify.formatMoney(productCurrentPrice);
      }
    }
    return;
  }

  const featureAddons = document.querySelectorAll('.feature-select-options.current-variant select.addon-feature-select');
  const priceFeaturesSet = [];
  for (let featureAddon of featureAddons) {
    let selectedOption = featureAddon.options[featureAddon.selectedIndex];
    if (featureAddon.value !== "") {
      const optionPrice = parseInt(selectedOption.dataset.price);
      productCurrentPrice += optionPrice;
      if (regularCurrentPrice) {
        regularCurrentPrice += optionPrice;
      }
      if (featureAddon.value !== "") {
        setBsDropdownButtonText(selectedOption);
      }
      priceFeaturesSet.push(featureAddon.dataset.viewerLabel);
    }
    setRelativeOptionPriceText(featureAddon, selectedOption);
  }

  if (priceFeaturesSet.includes('Siding Type') && priceFeaturesSet.includes('Countertop Tile') && priceFeaturesSet.includes('Grill')) {
    if (document.querySelector('.product-template__body--price .costco-price span')) {
      document.querySelector('.product-template__body--price .costco-price span').innerHTML = Shopify.formatMoney(productCurrentPrice);
    }
    if (document.querySelector('.product-template__body--price .regular-price span')) {
      document.querySelector('.product-template__body--price .regular-price span').innerHTML = Shopify.formatMoney(regularCurrentPrice);
    }
    if (document.querySelector('.product-atc--price-text')) {
      document.querySelector('.product-atc--price-text').innerHTML = Shopify.formatMoney(productCurrentPrice);
    }
    document.querySelector('.product-atc-wrapper .product-atc--price').classList.remove('invisible');
    document.querySelector('.body--price__wrapper').classList.remove('invisible');    
  }
  else {
    document.querySelector('.product-atc-wrapper .product-atc--price').classList.add('invisible');
    document.querySelector('.body--price__wrapper').classList.add('invisible');
  }

}
function setRelativeOptionPriceText(featureAddon, selectedOption) {
  const selectedOptionPrice = parseInt(selectedOption.dataset.price);
  const notSelectedOptions = Array.from(featureAddon.options).filter((option, index) => index !== featureAddon.selectedIndex && option.value !== '' && selectedOption !== option);
  if (featureAddon.value !== "") {
    setBsDropdownItemText(selectedOption, '+ $0');
  }
  for (option of notSelectedOptions) {
    const priceText = calcPriceText(selectedOptionPrice);
    setBsDropdownItemText(option, priceText);
  }
}
function setBsDropdownButtonText(selectedOption) {
  // console.log("selectedOption",selectedOption);
  const optionValue = (selectedOption.dataset.labelUnique) ? selectedOption.dataset.labelUnique : selectedOption.value;
  const bsDropdownButton = document.querySelector(`.feature-select-options.current-variant button[data-viewer-label="${selectedOption.dataset.viewerLabel}"] .selected-option-text`);
  bsDropdownButton.innerHTML = optionValue;
}

function calcPriceText(selectedOptionPrice) {
  let priceText = "";
  const optionPrice = parseInt(option.dataset.price);
  if (optionPrice < selectedOptionPrice) {
    const priceDiff = selectedOptionPrice - optionPrice;
    priceText = `- ${Shopify.formatMoney(priceDiff)}`;
  }
  else if (optionPrice === selectedOptionPrice) {
    priceText = `+ $0`;
  }
  else {
    priceText = `+ ${Shopify.formatMoney(optionPrice)}`;
  }

  return priceText;
}
function setBsDropdownItemText(option, priceText) {
  const variantId = option.dataset.variantId;
  const optionValue = (option.dataset.labelUnique) ? option.dataset.labelUnique : option.value;
  const bsDropdownOption = document.querySelector(`.feature-select-options.current-variant .feature-dropdown-item[data-variant-id="${variantId}"]`);
  bsDropdownOption.querySelector('.feature-dropdown-title').innerHTML = optionValue;
  bsDropdownOption.querySelector('.feature-dropdown-price').innerHTML = priceText;
}
function customFeatureUpdateLogic(featureItem) {
  console.log('featureItem', featureItem);
  const productTitle = document.querySelector('.product-template__body--title').innerHTML;
  const featureLabel = featureItem.dataset.viewerLabel;
  const featureValue = featureItem.dataset.viewerValue;
  const featureColorText = featureItem.dataset.labelUnique;
  if (featureLabel === 'Siding Type') {
    console.log('Siding Type update');
    const sidingColorsList = document.querySelectorAll('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"] ul li');
    switch (featureItem.dataset.viewerValue) {
      case 'No Siding': //hide Siding Color
        document.querySelector('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"]').classList.add('hidden');
        break;
      default:
        for (let sidingColor of sidingColorsList) {
          sidingColor.classList.add('hidden');
        }
        for (let sidingColor of sidingColorsList) {
          if (sidingColor.dataset.relatedOption === featureItem.dataset.viewerValue) {
            sidingColor.classList.remove('hidden');
          }
        }
        document.querySelector('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"]').classList.remove('hidden');        
        break;
    }
    document.querySelector('.feature-select-options.current-variant .dropdown-toggle[data-viewer-label="Siding Color"] .selected-option-text').innerHTML = "Select";
    if (featureValue.includes('Faux Rock')) {
      toggleInfoIcon('SidingType-Modal', true);
      toggleFeatureOption('Bottle Opener', '49647555576086', true); //set bottle opener to No
      toggleFeatureOption('Refrigerator', '49614423163158', true); //set refrigerator to the Standard Refrigerator
      if (productTitle.includes('Guemes')) {
        toggleGuemesDoorOptionForFauxRock(featureValue);
      }
    }
    else {
      toggleInfoIcon('SidingType-Modal', false);
      toggleInfoIcon('SidingTypeNone-Modal', false);

      if (featureValue.includes('No Siding')) {
        toggleInfoIcon('SidingTypeNone-Modal', true);
      }
      toggleFeatureOption('Bottle Opener', null, false);
      toggleFeatureOption('Refrigerator', null, false);
      
      if (productTitle.includes('Guemes')) {
        toggleGuemesDoorOptionForFauxRock(featureValue);
      }
    }
  }
  else if (featureLabel === 'Countertop Tile') {
    if (featureValue.includes('No Tile')) {
      toggleInfoIcon('CountertopTile-Modal', true);
    }
    else {
      toggleInfoIcon('CountertopTile-Modal', false);
    }
  }
  else if (featureLabel === 'Color') {
    document.querySelector('.feature-select-options.current-variant .dropdown-toggle[data-viewer-label="Siding Color"] .selected-option-text').innerHTML = featureColorText;
  }
  else if (featureLabel === 'Sink' && productTitle.includes('Camano')) {
    console.log('Camano Sink update, featureValue', featureValue);

    if (featureValue === 'true') {
      toggleInfoIcon('Sink-Modal', true);
      toggleFeatureOption('Second Door/Drawer', '49670374293782', true); //set Second Door/Drawer to vertical access door
    }
    else {
      toggleInfoIcon('Sink-Modal', false);
      toggleFeatureOption('Second Door/Drawer', null, false);
    }
  }
  else if (featureLabel === 'Grill') {
    toggleGrillOptionForDoor(featureValue);
    toggleGreaseTrays(featureValue);
  }
}

function toggleGuemesDoorOptionForFauxRock(featureValue) {
  const doorDrawerOptions = document.querySelectorAll('.product-form__input--dropdown[data-label="Door/Drawer"] .feature-dropdown-item');
  if (featureValue.includes('Faux Rock')) {
    //On the Guemes kitchen the selection of the Faux Rock siding needs to remove the 38" door options.
    doorDrawerOptions.forEach(option => {
      if (option.dataset.value.includes('38"')) {
        option.classList.add('hidden');
      }
    })
    //set door/drawer back to Select
    toggleFeatureOption('Door/Drawer', null, false);
  }
  else {
    doorDrawerOptions.forEach(option => {
        option.classList.remove('hidden');
    })
  }
}
function toggleGrillOptionForDoor(grillSize) {  
  const productTitle = document.querySelector('.product-template__body--title').innerHTML;
  const doorDrawerOptions = document.querySelectorAll('.product-form__input--dropdown[data-label="Door/Drawer"] .feature-dropdown-item');
  if (grillSize.includes('30"') || productTitle.includes('Guemes')) {
    //ensure door/drawer selection shown is not larger than grill size
    doorDrawerOptions.forEach(option => {
      if (option.dataset.value.includes('38"')) {
        option.classList.add('hidden');
      }
    })
    //set door/drawer back to Select
    toggleFeatureOption('Door/Drawer', null, false);
  }
  else {
    doorDrawerOptions.forEach(option => {
        option.classList.remove('hidden');
    })
  }
}
function toggleGreaseTrays(grillSize) {
  // 49622979641622 --> 30" grease trays
  // 49669446926614 --> 38" grease trays
  const greaseTray30inQtyInput = document.querySelector('.step-three-options input[type="number"][data-variant-id="49622979641622"]');
  const greaseTray30inQtyInputAlt = greaseTray30inQtyInput.parentNode.querySelector('input[type="text"]');
  const greaseTray38inQtyInput = document.querySelector('.step-three-options input[type="number"][data-variant-id="49669446926614"]');
  const greaseTray38inQtyInputAlt = greaseTray38inQtyInput.parentNode.querySelector('input[type="text"]');
  console.log('greaseTray30inQtyInput',greaseTray30inQtyInput);
  console.log('greaseTray30inQtyInputAlt',greaseTray30inQtyInputAlt);  
  console.log('greaseTray38inQtyInput',greaseTray38inQtyInput);
  console.log('greaseTray38inQtyInputAlt',greaseTray38inQtyInputAlt);
  greaseTray30inQtyInput.value = 0;
  greaseTray30inQtyInputAlt.value = 0;
  greaseTray38inQtyInput.value = 0;
  greaseTray38inQtyInputAlt.value = 0;
  if (greaseTray30inQtyInput && greaseTray38inQtyInput) {
    if (grillSize.includes('30"')) {
      //show the 30" grease trays
      document.querySelectorAll('.step-three-options div[toggle-variant-id="49622979641622"]').forEach(element => {
        element.classList.remove('hidden');
      });  
      //hide the 38" grease trays and set qty to 0
      document.querySelectorAll('.step-three-options div[toggle-variant-id="49669446926614"]').forEach(element => {
        element.classList.add('hidden');
      }); 
      
    }
    else if (grillSize.includes('38"')) {
      //show the 38" grease trays
      document.querySelectorAll('.step-three-options div[toggle-variant-id="49669446926614"]').forEach(element => {
        element.classList.remove('hidden');
      });  
      //hide the 30" grease trays and set qty to 0
      document.querySelectorAll('.step-three-options div[toggle-variant-id="49622979641622"]').forEach(element => {
        element.classList.add('hidden');
      }); 

    }
  }
}

function toggleFeatureOption(featureOptionLabel, variantId, shouldDisable) {  
  console.log('toggleFeatureOption',featureOptionLabel, variantId, shouldDisable);
  const featureSelect = document.querySelector(`.feature-select-options.current-variant select[data-viewer-label="${featureOptionLabel}"]`);
  if (variantId) {
    //set the feature label of the dropdown
    const bsDropdownOption = document.querySelector(`.feature-select-options.current-variant .feature-dropdown-item[data-variant-id="${variantId}"]`);
    document.querySelector(`.feature-select-options.current-variant .dropdown-toggle[data-viewer-label="${featureOptionLabel}"] .selected-option-text`).innerHTML = bsDropdownOption.dataset.value;
    //set the hidden feature select
    const newValue = document.querySelector(`.feature-select-options.current-variant select[data-viewer-label="${featureOptionLabel}"] option[data-variant-id="${variantId}"]`).value;
    featureSelect.value = newValue;
  }
  else {
    document.querySelector(`.feature-select-options.current-variant .dropdown-toggle[data-viewer-label="${featureOptionLabel}"] .selected-option-text`).innerHTML = 'Select';
    featureSelect.value = '';
  }
  document.querySelector(`.feature-select-options.current-variant .dropdown-toggle[data-viewer-label="${featureOptionLabel}"]`).disabled = shouldDisable;
  
  const selectedOption = featureSelect.options[featureSelect.selectedIndex];
  if (selectedOption.dataset.viewerLabel && selectedOption.dataset.viewerValue) {
    updateViewerModel(selectedOption); 
  } 
}

function toggleInfoIcon(modalName, show) {
  const infoModal = document.querySelector(`.feature-select-options.current-variant .feature-info-icon[data-bs-target="#${modalName}"]`);
  if (show) {
    infoModal.classList.remove('invisible');
    infoModal.classList.remove('d-none');
    if (modalName === 'SidingTypeNone-Modal') {
      document.querySelector(`.feature-select-options.current-variant .feature-info-icon[data-bs-target="#SidingType-Modal"]`).classList.add('d-none');
    }
    else if (modalName === 'SidingType-Modal') {
      document.querySelector(`.feature-select-options.current-variant .feature-info-icon[data-bs-target="#SidingTypeNone-Modal"]`).classList.add('d-none');
    }

    const hasSeenModal = sessionStorage.getItem(`hasSeenModal${modalName}`);
    if (!hasSeenModal) {
      var myModal = new bootstrap.Modal(document.getElementById(`${modalName}`), {
        keyboard: false
      });
      myModal.show();
      sessionStorage.setItem(`hasSeenModal${modalName}`, true);
    }
  }
  else {
    infoModal.classList.add('invisible');
    if (modalName === 'SidingTypeNone-Modal') {
      infoModal.classList.add('d-none');
      document.querySelector(`.feature-select-options.current-variant .feature-info-icon[data-bs-target="#SidingType-Modal"]`).classList.remove('d-none');
    }
    else if (modalName === 'SidingType-Modal') {
      document.querySelector(`.feature-select-options.current-variant .feature-info-icon[data-bs-target="#SidingTypeNone-Modal"]`).classList.add('d-none');
    }
  }
}
function featureUpdated(el) {  
  toggleFeatureAlert(el.target.parentElement.parentElement.querySelector('.dropdown-toggle'), false);
  setHiddenFeatureSelect(el.target);
  setSidingTypeSelectFromColor();
  customFeatureUpdateLogic(el.target);
  setAlternateSidingTypeForGrill();
  updatePriceView();
  updateViewerModel(el.target);
  updateDropdownItem(el.target);
}

function updateDropdownItem(dropdownItem) {  
  const dropdownItems = dropdownItem.parentElement.querySelectorAll('.feature-dropdown-item');
  dropdownItems.forEach(item => {
    item.classList.remove('selected');
  });
  dropdownItem.classList.add('selected');

  const dropdowns = document.querySelectorAll('.product-form__input--dropdown');
  dropdowns.forEach(dropdown => {
    const dropdownItemSelected = dropdown.querySelector('select option:checked');
    const dropdownLabelPrice = dropdown.querySelector('.form__label--price');  
    let dropdownLabelPriceText = '';
    if (dropdownItemSelected) {            
      const priceText = Shopify.formatMoney(dropdownItemSelected.dataset.price);      
      dropdownLabelPriceText = (dropdownItemSelected.dataset.price > 0) ? `+ ${priceText}` : '';
    }
    dropdownLabelPrice.textContent = dropdownLabelPriceText;   
  });
}

function updateViewerModel(el) {  
  const viewerLabel = setViewerLabel(el.dataset.viewerLabel);
  const viewerValue = setViewerValue(el.dataset.viewerValue);
  // console.log([featureUpdated,el.target]);  
  sendMessage(viewerLabel, viewerValue);
}

function setViewerLabel(dataLabel) {
  let viewerLabel = dataLabel;
  switch (dataLabel) {
    case 'Siding Type':
      viewerLabel = "Base Material Options";
      break;
    case 'Refrigerator':
      viewerLabel = "Refrigeration Options";
      break;
    case 'Umbrella Hole':
      viewerLabel = "Umbrella hole";
      break;
  }

  return viewerLabel;
}

function setViewerValue(dataValue) {
  let viewerValue = dataValue;
  // console.log("viewerValue",viewerValue);
  switch (dataValue) {
    case 'true':
      viewerValue = true;
      break;
    case 'false':
      viewerValue = false;
      break;
  }
  // console.log("viewerValue",viewerValue);

  return viewerValue;
}

function sendMessage(label, val) {
  console.log("setting feature", [label, val])
  const iframe = document.querySelector('#modelViewerFrame');
  const data = {
    label: `${label}`,
    value: (val === true || val === false) ? val : `${val}`,
  };
  console.log('passing feature data to iframe', data);
  if (iframe) {
    // console.log("posting message to iframe")
    iframe.contentWindow.postMessage(data, '*');
  }
}

function setAlternateSidingTypeForGrill() {
  const sidingTypeSelect = document.querySelector(`.feature-select-options.current-variant select.addon-feature-select[data-viewer-label="Siding Type"]`);
  // when Brahma grill type has been selected, change underlying selected siding type product based on siding type and siding color values to the Brama siding type variant
  const grillSelect = document.querySelector(`.feature-select-options.current-variant select.addon-feature-select[data-viewer-label="Grill"]`);
  if (grillSelect.value.includes('Brahma')) {
    console.log('grill contains brahma',grillSelect.value);
    //find the siding type and siding color that corresponds to the brahma hidden brahma siding type select
    const colorSelected = document.querySelector('.feature-select-options.current-variant .dropdown-toggle[data-viewer-label="Siding Color"] .selected-option-text').innerHTML;    
    if (sidingTypeSelect.value !== "" && colorSelected !== "") {
      for (let sidingTypeOption of sidingTypeSelect.options) {
        if (sidingTypeOption.value.includes('Brahma') && sidingTypeOption.value.includes(colorSelected)) {
          sidingTypeSelect.value = sidingTypeOption.value;
          break;
        }
      }
    }
  }       
}

function setHiddenFeatureSelect(featureItem) {
  const featureLabel = featureItem.dataset.viewerLabel;  
  const colorFeatureItems = document.querySelectorAll('.feature-select-options.current-variant .product-form__input--dropdown[data-label="Siding Color"] .feature-dropdown-item');
  if (featureLabel !== 'Color') {
    const featureSelect = document.querySelector(`.feature-select-options.current-variant select.addon-feature-select[data-viewer-label="${featureItem.dataset.viewerLabel}"]`);
    featureSelect.value = featureItem.dataset.value;
    if (featureLabel === 'Siding Type') {
      for (let colorFeatureItem of colorFeatureItems) {
        colorFeatureItem.classList.remove('selected');
      }
    }
  }  
  else {    
    for (let colorFeatureItem of colorFeatureItems) {
      if (colorFeatureItem.dataset.relatedVariantId === featureItem.dataset.relatedVariantId) {
        colorFeatureItem.classList.add('selected');
      }
      else {
        colorFeatureItem.classList.remove('selected');
      }
    }
  }
}
function setSidingTypeSelectFromColor() {
  const colorSelected = document.querySelector('.feature-select-options.current-variant .product-form__input--dropdown[data-label="Siding Color"] .feature-dropdown-item.selected');
  if (colorSelected) {
    const sidingTypeSelect = document.querySelector(`.feature-select-options.current-variant select.addon-feature-select[data-viewer-label="Siding Type"]`);
    const relatedVariantId = colorSelected.dataset.relatedVariantId;
    const newSidingTypeOption = document.querySelector(`.feature-select-options.current-variant select option[data-variant-id="${relatedVariantId}"`);    
    sidingTypeSelect.value = newSidingTypeOption.value;
  }  
}
function toggleAddToCart(show) {
  const productAtcWrapper = document.querySelector('.product-atc--submit');
  const productAtc = document.querySelector('.product-atc');
  if (show) {
    productAtc.removeAttribute('disabled');
    productAtcWrapper.classList.add('enabled');
    productAtc.classList.remove('pe-none', 'disabled');
  }
  else {
    productAtc.setAttribute('disabled', true);
    productAtc.classList.add('pe-none', 'disabled');
    productAtcWrapper.classList.remove('enabled');
  }
}
function validateFeaturesSelected() {
  const productType = document.getElementById('product-kitchen-form').dataset.productType;
  if (productType === 'Kitchen Island Pre-Built') {
    return true;
  }

  const featureSelects = document.querySelectorAll('.feature-select-options.current-variant select');
  const gasTypeInput = document.querySelector('input[name="Gas Type"]:checked').value;
  const colorOptionSelected = document.querySelector('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"] .dropdown-toggle .selected-option-text').innerHTML;
  const sidingTypeSelected = document.querySelector(`.feature-select-options.current-variant select.addon-feature-select[data-viewer-label="Siding Type"]`).value;
  const colorOptionNotSelected = (colorOptionSelected === 'Select' && sidingTypeSelected !== 'No Siding');
  // console.log([colorOptionSelected, sidingTypeSelect.value, colorOptionNotSelected])
  let allFeaturesSelected = (gasTypeInput === 'None' || colorOptionNotSelected) ? false : true;
  for (let featureSelect of featureSelects) {
    if (featureSelect.value === "") {
      allFeaturesSelected = false;
    }
  }

  console.log("allFeaturesSelected",allFeaturesSelected)
  return allFeaturesSelected;
}
function alertFeaturesUnselected() {
  const featureSelects = document.querySelectorAll('.feature-select-options.current-variant select');
  const sidingTypeSelected = document.querySelector(`.feature-select-options.current-variant select.addon-feature-select[data-viewer-label="Siding Type"]`).value;
  const colorOptionSelected = document.querySelector('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"] .dropdown-toggle .selected-option-text').innerHTML;
  let elFocused = false;
  if (colorOptionSelected === 'Select' && sidingTypeSelected !== 'No Siding') {
    toggleFeatureAlert(document.querySelector('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"] .dropdown-toggle'), true);
    if (!elFocused && sidingTypeSelected) {
      setFocusOnElement(document.querySelector('.feature-select-options.current-variant .product-form__input[data-label="Siding Color"] .dropdown-toggle'));
      elFocused = true;
    }
  }

  for (let featureSelect of featureSelects) {
    if (featureSelect.value === "") {
      toggleFeatureAlert(featureSelect.parentElement.querySelector('.dropdown-toggle'), true);
      if (!elFocused) {
        setFocusOnElement(featureSelect.parentElement.querySelector('.dropdown-toggle'));
        elFocused = true;
      }
    }
  }
}
function setFocusOnElement(el) {
  el.focus();
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
}
function toggleFeatureAlert(element, showAlert) {
  // console.log('toggleFeatureAlert',element);
  if (showAlert) {
    element.classList.add('is-invalid')
  }
  else {
    element.classList.remove('is-invalid')
  }
}

function debounce(func, delay) {
  let timeoutId;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}
const debouncedScrollFunction = debounce(scrollFunction, 50);
window.onscroll = debouncedScrollFunction;

function scrollFunction() {
  atcRef = document.querySelector(".atc-ref");
  if (atcRef) {
    const rect = atcRef.getBoundingClientRect();
    const atcWrapper = document.querySelector('.product-atc-wrapper');
    const screenWidth = window.innerWidth;
    if (
      (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
      ||
      (rect.bottom < 0)
    ) {
      atcWrapper.classList.add('position-relative');      
      
      if (screenWidth > 991) {
        atcWrapper.classList.add('h-auto');
        atcWrapper.classList.remove('open');  
      }
      else {
        atcWrapper.classList.remove('h-auto');
        atcWrapper.classList.add('open');      
      }
    } else {
      atcWrapper.classList.remove('position-relative');      
      atcWrapper.classList.remove('h-auto');
    }        
  }
}